export default __webpack_public_path__ + "static/media/header-user.689261b4.svg";